import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { motion } from "framer-motion";
import { calculateDaysBetween, calculatePrice, checkUnit } from '../js/function.js'

const BookReview = ({ disabledMoreInfo,relocationFee,youngdriverFee,olddriverFee }) => {
  const today = new Date();
  const images = require.context('../img', false, /\.svg$/);
  const formattedDate = today.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const searchData = useSelector((state) => state.data.searchData);
  const selectedExtraOptions = useSelector((state) => state.data.selectedExtraOptions);
  const initData = useSelector((state) => state.data.initData);
  const [isOpenBookingReview, setIsOpenBookingReview] = useState(false);
  const days = calculateDaysBetween(searchData.startDate, searchData.startTime, searchData.endDate, searchData.endTime)
  const basePrice = calculatePrice(searchData.vehiclePrice, initData, searchData, days, selectedExtraOptions, relocationFee,youngdriverFee,olddriverFee)

  return (
    <div className="">
      <div className={disabledMoreInfo ? 'text-start mt-3 text-2xl font-semibold pb-2 border-b-2 border-gray-200 px-2' : 'my-6 px-2'}>
        <span className="block text-gray-900 font-bold">Booking Review</span>
        <span className="block text-gray-400 text-sm">{formattedDate}</span>
      </div>
      <div className="mb-3 text-left">
        <div className="px-4 w-full py-4 border-b-2 border-gray-200">
          <div className="text-l text-gray-800">Pickup / Return</div>
          <div className='mt-2'>
            <div className='text-gray-400 text-sm'>Pickup</div>
            <div className='font-bold'>{initData.branches?.[searchData.pickup].name}</div>
            <div className='font-bold'>{searchData.startDate + ' - ' + searchData.startTime}</div>
          </div>
          <div className='mt-2'>
            <div className='text-gray-400 text-sm'>Return</div>
            <div className='font-bold'>{searchData.dropoff === 'same_as_pickup' ? 'Same as pick up' : initData.branches?.[searchData.dropoff].name}</div>
            <div className='font-bold'>{searchData.endDate + ' - ' + searchData.endTime}</div>
          </div>
          <div className='mt-2'>
            <div className='text-gray-400 text-sm'>Renter Age</div>
            <div className='font-bold'>{searchData.driverage}</div>
          </div>
        </div>
        <div className="px-4 w-full py-4 border-b-2 border-gray-200">
          <div className="text-l text-gray-800">Vehicle Details</div>
          {searchData.vehicleDetails && searchData.vehicleDetails.length !== 0 ?
            <div>
              <div className='block'>
                {searchData.vehicleDetails.url && <img className='m-auto max-w-60' alt='vehicleImg' src={searchData.vehicleDetails.url} />}
                <div className='flex-1 flex flex-col'>
                  <div className='font-bold'>{searchData.vehicleDetails.title}</div>
                  <div className='font-bold text-lg mb-1'>{searchData.vehicleDetails.type}</div>
                  <div className="grid grid-cols-2 gap-x-1 text-sm mt-1">
                    {searchData.vehicleDetails.specs && searchData.vehicleDetails.specs.map((i, id) => (
                      <div className='flex items-center' key={id + 'specs'}>
                        <img src={images(`./${i.label}.svg`)} className='w-4 h-4 mr-2' alt={i.label} />
                        <div>{i.value}</div>
                      </div>
                    ))}
                  </div>
                  {!disabledMoreInfo &&
                    <div className='group relative inline mt-2 inline-block'>
                      <span className='text-sm text-primary cursor-pointer' onClick={() => setIsOpenBookingReview(!isOpenBookingReview)}>+ More Information</span>
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={isOpenBookingReview ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="overflow-hidden"
                      >

                        <div className="py-1 text-sm">
                          {searchData.vehicleDetails.more_info && searchData.vehicleDetails.more_info.map((data, i) => (
                            <div key={i} className='m-1 mb-2 overflow-visible'>
                              <div className='capitalize font-bold'>{data.title}</div>
                              <div className='max-w-60'>{data.string && data.string}</div>
                              <div className=''>
                                {data.array && data.array.map((d, y) => (
                                  <div key={y} className='whitespace-normal'>+ {d}</div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </motion.div>
                    </div>
                  }
                </div>
              </div>
            </div>
            : '-'}
        </div>
        <div className="px-4 w-full py-4 border-b-2 border-gray-200">
          <div className="text-l text-gray-800">Damage Liability</div>
          <div className='font-bold'>{searchData.damageLiability && searchData.damageLiability !== '' ? initData?.insurance?.[searchData.damageLiability]?.title : '-'}</div>
        </div>
        <div className='px-4 w-full py-4 border-b-2 border-gray-200'>
          <div className="text-l text-gray-800">Kilometers</div>
          <div className='font-bold text-sm'>{initData.included_kilometres?.[searchData.included_kilometres]?.title}</div>
        </div>
        <div className="w-full py-4 border-b-2 border-gray-200">
          <div className='mx-4'>
            <div className="text-l text-gray-800">Final Price</div>
            <div className='mt-2'>
              <div className='text-gray-400 text-sm'>Piricing</div>
              <div className='font-bold text-sm'>
                <div className="flex justify-between">
                  <p>Rental Rate</p>
                  <p>${searchData.vehiclePrice}</p>
                  {/* <p>${parseFloat(itemPrice[searchData?.vehicleDetails?.url]?.price).toFixed(2)}</p> */}
                </div>
                <div className="flex justify-between">
                  <p>{initData?.insurance?.[searchData.damageLiability]?.title}</p>
                  <p>${parseFloat(initData?.insurance?.[searchData.damageLiability]?.price).toFixed(2)}{checkUnit(initData?.insurance?.[searchData.damageLiability].unit, days)}</p>
                </div>
                {Object.entries(selectedExtraOptions).map(([key, value]) => (
                  <div className="flex justify-between" key={key}>
                    {/* {value} */}
                    <p>{initData?.options[key]?.title}</p>
                    <p>${parseFloat(initData?.options[key]?.price).toFixed(2)}{checkUnit(initData?.options[key]?.unit, days, selectedExtraOptions[key])}</p>
                  </div>
                ))}
                <div className="flex justify-between">
                  <p>{initData.included_kilometres?.[searchData.included_kilometres]?.title}</p>
                  <p>${parseFloat(initData.included_kilometres?.[searchData.included_kilometres]?.price).toFixed(2)}{checkUnit(initData.included_kilometres?.[searchData.included_kilometres].unit, days)}</p>
                </div>
                <div>
                  {searchData.dropoff !== 'same_as_pickup' && searchData.dropoff !== searchData.pickup && (
                    <div className="flex justify-between">
                      <p>Relocation</p>
                      <p>${relocationFee}</p>
                    </div>
                  )}
                </div>
                <div>
                  {searchData.driverage?.includes('21') && (
                    <div className="flex justify-between">
                      <p>Young Driver Fee</p>
                      <p>${youngdriverFee} X {days}</p>
                    </div>
                  )}
                  {searchData.driverage?.includes('65') && (
                    <div className="flex justify-between">
                      <p>Old Driver Fee</p>
                      <p>${olddriverFee} X {days}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <div className='mt-2'>
              <div className='text-gray-400 text-sm'>Taxes - 10% GST</div>
              <div className='font-bold text-sm flex justify-between' >
                <p>GST</p>
                <p>${(parseFloat(basePrice).toFixed(2) * 0.1).toFixed(2)}</p>
              </div>
            </div> */}
          </div>
          <div className='mt-2 py-2 px-4 text-white bg-primary'>
            <div className='font-bold text-lg'>TOTAL</div>
            <div className='font-bold text-xl'>AUD <span className='text-3xl'>
              {/* {(basePrice * 1.1).toFixed(2)} */}
              {(basePrice).toFixed(2)}
            </span></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookReview;
